import * as React from 'react'
import { Tabs } from 'antd'
import { TabsType } from 'antd/lib/tabs'

export enum ProductTab {
  PRICING = 'Pricing',
  INVENTORY = 'Inventory',
  DISCOUNTS = 'Discounts',
  BARCODE = 'Barcode',
  DESCRIPTIONS = 'Descriptions',
  DETAILS = 'Details',
  EDIT_HISTORY = 'Edit history',
  CANNABINOIDS = 'Cannabinoids',
  CANNABINOIDS_BATCH = 'Cannabinoids',
  CUSTOM_FIELDS = 'Custom fields',
  TAGS = 'Tags',
}

interface TabProp {
  tab: ProductTab
  content: JSX.Element
  isVisible?: boolean
}

interface Props {
  type?: TabsType
  tabClassName?: string
  tabs: TabProp[]
}

export const ProductTabs = (props: Props) => {
  const [width, setWidth] = React.useState(window.innerWidth)

  React.useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))

    return function cleanup() {
      window.removeEventListener('resize', () => setWidth(window.innerWidth))
    }
  }, [])

  return (
    <Tabs
      type={props.type}
      tabPosition={width <= 768 ? 'top' : 'left'}
      className={props.tabClassName}
    >
      {props.tabs.map(({ tab, content, isVisible }) => {
        return (
          isVisible !== false && (
            <Tabs.TabPane tab={tab} key={tab}>
              {content}
            </Tabs.TabPane>
          )
        )
      })}
    </Tabs>
  )
}
